import { useSelector } from 'react-redux'

import { selectUserAllowGps } from '@/features/domain/user'

export function useAllowGps() {
  return useSelector(selectUserAllowGps)
}
